var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-header"},[_c('h2',{staticClass:"section-header__title",domProps:{"textContent":_vm._s(_vm.title)}}),(_vm.subTitle)?_c('p',{staticClass:"section-header__text",domProps:{"textContent":_vm._s(_vm.subTitle)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }